export enum Env {
  BETA = "beta",
  PROD = "production",
}
export interface MZTConf {
  env: Env;
  service: string;
}
